import { useEffect } from 'react';
import { ANALYTICS_EVENTS, PRODUCTS } from '../constants';
import { Checkbox, InputTextColors, getColor } from '@atlassiansox/wpl-utils';
import { Product } from '../models';
import { useGlobalStore } from '../store';
import {
  containerStyle,
  nameStyle,
  selectableProductContainerStyle,
  selectableProductStyle
} from './product-selection-list.styles';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { productIconStyle } from './product-family-container/product-family-container.styles';

export type ProductSelectionListProps = {
  readonly selectableProducts: Product[];
};

const ProductSelectionList = () => {
  const [
    { selectedProductNames },
    { toggleProductSelection: toggleProductSelection }
  ] = useGlobalStore();
  const { createAnalyticsEvent } = useAnalyticsEvents();

  useEffect(() => {
    if (selectedProductNames.size > 0) {
      createAnalyticsEvent({
        action: 'click',
        component: 'button',
        eventName: ANALYTICS_EVENTS.updateProductList,
        selectedProducts: Array.from(selectedProductNames)
      }).fire();
    }
  }, [selectedProductNames]);

  return (
    <div css={containerStyle}>
      {PRODUCTS.map(({ name, icon }) => {
        return (
          <button
            data-testid={`product-selection-list-${name}`}
            css={selectableProductContainerStyle}
            key={name}
            onClick={() => {
              toggleProductSelection(name);
            }}
          >
            <div css={selectableProductStyle}>
              <Checkbox
                id={name}
                name={name}
                value={name}
                color={InputTextColors.Light}
                accentColor={getColor('b400')}
                checked={selectedProductNames.has(name)}
              />
              <div css={productIconStyle}>{icon}</div>
              <div css={nameStyle}>{name}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ProductSelectionList;
